import type { MenuContextValue } from '@fluentui/react-menu';

export type {
  MenuBaseProps as MenuProps,
  MenuBaseState as MenuState,
  MenuContextValue,
  MenuOpenChangeData,
  MenuOpenEvent,
} from '@fluentui/react-menu';

export type MenuContextValues = { menu: MenuContextValue };
